import React from 'react'

import { Box, Skeleton, Stack } from '@mui/material'

import { theme } from 'styles/theme'

/**
 * Esqueleto propositalmente grosseiro: blocos largos que só marcam a região de
 * cada bloco de conteúdo. Reproduzir campo a campo faz o carregamento parecer
 * conteúdo real e chama mais atenção do que a tela que está chegando.
 */
const Loading: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" gap="16px" marginTop="8px">
      {/* Faixa do topo: marca de leitura à esquerda e os botões de ação à
          direita. O chip de status e o "..." ficam na barra de título. */}
      <Box alignItems="center" display="flex" flexWrap="wrap" gap="8px">
        <Skeleton height="24px" variant="circular" width="24px" />
        <Box alignItems="center" display="flex" gap="8px" marginLeft="auto">
          <Skeleton height="36px" variant="rounded" width="150px" />
          <Skeleton height="36px" variant="rounded" width="140px" />
        </Box>
      </Box>

      <Box
        sx={{
          padding: '16px',
          border: '1px solid #E8EBE8',
          // Mesma borda de acento do ChargeSession, senão a caixa muda de cor
          // quando o conteúdo entra.
          borderLeft: `3px solid ${theme.palette.primary.main}`,
          borderRadius: '8px',
          backgroundColor: '#fff'
        }}
      >
        <Stack gap="16px">
          <Box
            alignItems="center"
            display="flex"
            gap="14px"
            paddingBottom="16px"
            sx={{ borderBottom: '1px solid #E8EBE8' }}
          >
            <Skeleton height="38px" variant="circular" width="38px" />
            <Stack flex={1} gap="6px">
              <Skeleton height="20px" variant="rounded" width="30%" />
              <Skeleton height="14px" variant="rounded" width="55%" />
            </Stack>
          </Box>

          <Box
            display="grid"
            gap="18px"
            sx={{
              gridTemplateColumns: '200px 1fr',
              [theme.breakpoints.down(760)]: {
                gridTemplateColumns: '1fr'
              }
            }}
          >
            <Stack
              gap="10px"
              paddingRight="20px"
              sx={{ borderRight: '1px solid #E8EBE8' }}
            >
              <Skeleton height="34px" variant="rounded" />
              <Skeleton height="20px" variant="rounded" width="70%" />
            </Stack>

            <Box
              display="grid"
              gap="16px"
              sx={{
                gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))'
              }}
            >
              <Skeleton height="30px" variant="rounded" />
              <Skeleton height="30px" variant="rounded" />
              <Skeleton height="30px" variant="rounded" />
              <Skeleton height="30px" variant="rounded" />

              {/* Meios de pagamento e tags vêm como chips e ocupam a linha
                  inteira, então o esqueleto reserva a faixa toda. */}
              <Box
                display="flex"
                flexWrap="wrap"
                gap="8px"
                sx={{ gridColumn: '1 / -1' }}
              >
                <Skeleton height="28px" variant="rounded" width="110px" />
                <Skeleton height="28px" variant="rounded" width="90px" />
                <Skeleton height="28px" variant="rounded" width="140px" />
                <Skeleton height="28px" variant="rounded" width="120px" />
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>

      {/* A composição abre expandida, então o esqueleto reserva a altura da
          tabela — senão o resto do modal salta ao carregar. */}
      <Box
        sx={{
          padding: '16px',
          border: '1px solid #E8EBE8',
          borderLeft: `3px solid ${theme.palette.primary.main}`,
          borderRadius: '8px',
          backgroundColor: '#fff'
        }}
      >
        <Box alignItems="center" display="flex" gap="12px">
          <Skeleton height="35px" variant="circular" width="35px" />
          <Skeleton height="22px" variant="rounded" width="220px" />
        </Box>

        <Stack gap="12px" marginTop="20px">
          <Skeleton height="26px" variant="rounded" />
          <Skeleton height="26px" variant="rounded" />
          <Skeleton height="26px" variant="rounded" />
        </Stack>
      </Box>

      <Skeleton height="60px" variant="rounded" />
    </Box>
  )
}

export default Loading
